/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router';

// Context
import { FilterBarContext } from '../../../filter-bar/context/filter-bar-context';
import ContentDetailDashboardMenuProvider from '../../content-detail-context/content-detail-dashboard-menu-context';

// Core
import { useDispatch } from 'react-redux';

// Config
import { config } from '../configurations/content-detail-dashboard-comparison';

// Components
import SectionDashboard from '../../../section-dashboard/components/section-dashboard';

// Redux
import { setDescription, setTitle } from '../../../redux/actions/page-meta';

// Types
import { FilterBarContextValues } from '../../../filter-bar/types';
import { RouteLocation } from '../../../styled-components/theme-context/cubed-theme-context';

const ContentDetailDashboardComparison = () => {
    const dispatch = useDispatch();

    const location = useLocation() as RouteLocation;
    location.isSectionDashboard = true;

    const {
        setFilterStatus,
        setDatePickerConfig,
        setFilterMetricsOptions,
        setComparisonDatePickerConfig,
        setComparisonFilterStatus,
    } = useContext(FilterBarContext) as FilterBarContextValues;

    useEffect(() => {
        dispatch(setTitle(config.title));
        dispatch(setDescription(config.description));

        // Filter bar configurations
        setFilterStatus(config.filters.status);
        setComparisonFilterStatus(config.filters.comparisonStatus); // Comparison status
        setFilterMetricsOptions([]); // reset metrics
        setDatePickerConfig(config.filters.datePicker); // reset datepicker
        setComparisonDatePickerConfig(config.filters.datePicker); // reset datepicker
    }, []);

    return (
        <ContentDetailDashboardMenuProvider>
            <SectionDashboard config={config} />
        </ContentDetailDashboardMenuProvider>
    );
};

export default ContentDetailDashboardComparison;
